// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JHKJ","rootMobile":"styles_rootMobile__29Kfz"};